import { HttpErrorResponse, HttpHeaders, HttpInterceptorFn } from '@angular/common/http';
import {catchError, first, switchMap, throwError} from 'rxjs';
import {selectQueryParams} from '../../store/router/router.selectors';
import {Store} from '@ngrx/store';
import {inject} from '@angular/core';
import {QUERY_SESSION_TOKEN,} from '../../constants/url-params';
import {ErrorManagerService} from '../../services/error-manager';
import {ErrorMessage, ErrorMessageLabel} from '../../constants/error';
import {LoggerService} from '@kamp-n/ng-logger';

export const SessionTokenInterceptor: HttpInterceptorFn = (req, next) => {
	const errorService = inject(ErrorManagerService);
	const logger = inject(LoggerService);
	return inject(Store).select(selectQueryParams).pipe(
		first(),
		switchMap((params) => {
			const authReq = req.clone({
				headers: new HttpHeaders().set('Authorization', `Bearer ${params[QUERY_SESSION_TOKEN]}`)
			});
			return next(authReq);
		}),
		catchError((err: any) => {
			if(err instanceof HttpErrorResponse) {
				// Handle HTTP errors
				if(err.status === 401) {
					// Specific handling for unauthorized errors
					logger.error(err.error.message);
					errorService.handle(ErrorMessageLabel[ErrorMessage.Authorization]);
				}
				else {
					// Handle other HTTP error codes
					logger.error(err.error.message);
					errorService.handle(ErrorMessageLabel[ErrorMessage.Server]);
				}
			}
			else {
				// Handle non-HTTP errors
				logger.error(err.error.message);
				errorService.handle(ErrorMessageLabel[ErrorMessage.Default]);
			}

			// Re-throw the error to propagate it further
			return throwError(() => err);
		})
	);
};
